module.exports = __webpack_public_path__ + "img/icons8-bola-24.ed106993.svg";